module.exports = __webpack_public_path__ + "img/map-widget-illustration-1.51b7199f.png";